import { Fragment, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ClipLoader from 'react-spinners/ClipLoader';
import MainPagetitle from '../../layouts/MainPagetitle';
import AdminSubscriberService from '../../../API/Services/AdminService/AdminSubscriberService';
import PriceComponent from '../../components/Price/PriceComponent';
import '../Subdivision/subdivisionList.css';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import swal from "sweetalert";
import { Offcanvas } from 'react-bootstrap';
import DateComponent from '../../components/date/DateFormat';
import { MultiSelect } from 'react-multi-select-component';
import AdminUserRoleService from '../../../API/Services/AdminService/AdminUserRoleService';
import Swal from "sweetalert2";

const SubscriberList = () => {
  const navigate = useNavigate();
  const SyestemUserRole = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).role : "";
  const [isLoading, setIsLoading] = useState(false);
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPage = 100;
  const lastIndex = currentPage * recordsPage;
  const [npage, setNpage] = useState(0);
  const number = [...Array(npage + 1).keys()].slice(1);
  const [subscriberList, setSubscriberList] = useState([]);
  const [subscriberListCount, setSubscriberListCount] = useState("");
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showDataTypesEditor, setShowDataTypesEditor] = useState(false);
  const [subscriptionDataTypeOptions, setSubscriptionDataTypeOptions] = useState([]);
  const [selectedDataTypeOptions, setSelectedDataTypeOptions] = useState([]);
  const [isSavingDataTypes, setIsSavingDataTypes] = useState(false);
  const [dataTypeErrorMessage, setDataTypeErrorMessage] = useState("");

  const [manageFilterOffcanvas, setManageFilterOffcanvas] = useState(false);
  const [updatingUserId, setUpdatingUserId] = useState(null);
  const [subscriptionPlanList, setSubscriptionPlanList] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);

  const defaultFilters = {
    company: [],
    plan: [],
    status: [],
    payment_status: [],
    price: "",
  };

  const [filterQuery, setFilterQuery] = useState(defaultFilters);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const changeCPage = (id) => {
    setCurrentPage(id);
  };

  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("usertoken")) {
      GetSubscriberList(currentPage, sortConfig, filterQuery);
      GetSubscriptionPlanDataType();
    } else {
      navigate("/");
    }
  }, [currentPage]);

  useEffect(() => {
    if (manageFilterOffcanvas) {
      GetUserCompanyList();
      GetSubscriptionPlanList();
    }
  }, [manageFilterOffcanvas]);

  const stringifySortConfig = (sortConfig = []) => {
    return Array.isArray(sortConfig)
      ? sortConfig.map((sort) => `${sort.key}:${sort.direction}`).join(",")
      : "";
  };

  const getCommaSeparatedValues = (selected = []) => {
    return Array.isArray(selected)
      ? selected.map((item) => item.value || item.label).filter(Boolean).join(", ")
      : "";
  };

  const buildSubscriberListPayload = (
    page = 1,
    sorting = sortConfig,
    filters = filterQuery,
  ) => {
    return {
      page,
      sortConfig: stringifySortConfig(sorting),
      company: getCommaSeparatedValues(filters.company),
      plan: getCommaSeparatedValues(filters.plan),
      status: getCommaSeparatedValues(filters.status),
      payment_status: getCommaSeparatedValues(filters.payment_status),
      price: filters.price?.trim() || "",
    };
  };

  const fetchSubscriberListData = async (
    page = currentPage,
    sorting = sortConfig,
    filters = filterQuery,
  ) => {
    const payload = buildSubscriberListPayload(page, sorting, filters);

    const response = await AdminSubscriberService.getSubscriberList(payload);
    const responseData = await response.json();

    return responseData;
  };

  const GetSubscriberList = async (
    page = currentPage,
    sorting = sortConfig,
    filters = filterQuery,
  ) => {
    setIsLoading(true);

    try {
      const responseData = await fetchSubscriberListData(page, sorting, filters);

      if (responseData.status == true) {
        setSubscriberList(responseData.data);
        setNpage(Math.ceil(responseData.data.length / recordsPage));
        setSubscriberListCount(responseData.data.length);
      }
    } catch (error) {
      if (error.name === "HTTPError") {
        console.error(error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const GetSubscriptionPlanDataType = async () => {
    try {
      const responseData = await AdminSubscriberService.getSubscriptionDataType().json();
      if (responseData.status === true) {
        setSubscriptionDataTypeOptions(
          responseData.data.map((item) => ({
            label: item.title,
            value: item.id,
          }))
        );
      }
    } catch (error) {
      if (error.name === "HTTPError") {
      }
    }
  };
  const [showSort, setShowSort] = useState(false);

  const handleSortClose = () => setShowSort(false);

  const [showSortingPopup, setShowSortingPopup] = useState(false);
  const [sortConfig, setSortConfig] = useState(() => {
    const savedSortConfig = localStorage.getItem("sortConfigSubscriberList");
    return savedSortConfig ? JSON.parse(savedSortConfig) : [];
  });
  const [selectedCheckboxes, setSelectedCheckboxes] = useState(sortConfig.map(col => col.key));

  const HandleSortDetailClick = (e) => {
    setShowSort(true);
  };
  const handleSortCheckboxChange = (e, key) => {
    if (e.target.checked) {
      setSelectedCheckboxes(prev => [...prev, key]);
    } else {
      setSelectedCheckboxes(prev => prev.filter(item => item !== key));
    }
  };

  const handleRemoveSelected = () => {
    const newSortConfig = sortConfig.filter(item => selectedCheckboxes.includes(item.key));
    setSortConfig(newSortConfig);
    setSelectedCheckboxes([]);
  };
  const [fieldList, setFieldList] = useState([
    "First Name",
    "Last Name",
    "Email",
    "Company Name",
    "Seats",
    "Subscription Title",
    "Subscription Type",
    "Subscription Status",
    "Subscription Price",
    "Payment Status",
    "Subscription Start",
    "Subscription Renewed",
    // "Subscription Content",
    "Action"
  ]);

  const handleDelete = async (id) => {
    try {
      let responseData = await AdminSubscriberService.destroy(id).json();
      if (responseData.status == true || responseData.status == "success") {
        GetSubscriberList(currentPage, sortConfig);
      }
    } catch (error) {
      setIsLoading(false);
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        console.error(errorJson.message);
      }
    }
  };

  const fieldKeyMap = {
    "First Name": "name",
    "Last Name": "last_name",
    "Email": "email",
    "Company Name": "company",
    "Seats": "seats",
    "Subscription Title": "subscription_title",
    "Subscription Type": "subscription_type",
    "Subscription Status": "subscription_status",
    "Subscription Price": "subscription_price",
    "Payment Status": "payment_status",
    "Subscription Start": "subscription_start_at",
    "Subscription Renewed": "subscription_renewed_at",
  };

  useEffect(() => {
    const fieldOptions = fieldList
      .filter((field) => field !== "Action" && field !== "Seats" && field !== "Subscription Type" && field !== "Subscription Renewed")
      .map((field) => ({
        value: fieldKeyMap[field] || field.charAt(0).toLowerCase() + field.slice(1).replace(/\s+/g, ""),
        label: field,
      }));

    setFieldOptions(fieldOptions);
  }, [fieldList]);

  // useEffect(() => {
  //   if (localStorage.getItem("usertoken")) {
  //     if (npage === currentPage) {
  //       return;
  //     } else {
  //       GetSubscriberList(npage === null ? currentPage : JSON.parse(npage), sortConfig);
  //     }
  //   } else {
  //     navigate("/");
  //   }
  // }, [currentPage]);

  const capitalizeFirstLetter = (text = "") =>
    text.charAt(0).toUpperCase() + text.slice(1);

  const HandleSortingPopupDetailClick = (e) => {
    setShowSortingPopup(true);
  };
  const handleSortingPopupClose = () => setShowSortingPopup(false);

  const [selectedFields, setSelectedFields] = useState(() => {
    const saved = localStorage.getItem("selectedFieldsSubscriber");
    return saved ? JSON.parse(saved) : [];
  });
  const [fieldOptions, setFieldOptions] = useState([]);
  const [selectionOrder, setSelectionOrder] = useState(() => {
    const saved = localStorage.getItem("selectionOrderSubscriber");
    return saved ? JSON.parse(saved) : {};
  });

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedFields(fieldOptions);
      const newOrder = {};
      fieldOptions.forEach((field, index) => {
        newOrder[field.value] = index + 1;
      });
      setSelectionOrder(newOrder);
    } else {
      setSelectedFields([]);
      setSelectionOrder({});
    }
  };


  const handleSortingCheckboxChange = (e, field) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setSelectedFields([...selectedFields, field]);
      setSelectionOrder((prevOrder) => ({
        ...prevOrder,
        [field.value]: Object.keys(prevOrder).length + 1,
      }));
    } else {
      setSelectedFields(selectedFields.filter((selected) => selected.value !== field.value));
      setSelectionOrder((prevOrder) => {
        const newOrder = { ...prevOrder };
        delete newOrder[field.value];
        const remainingFields = selectedFields.filter((selected) => selected.value !== field.value);
        remainingFields.forEach((field, index) => {
          newOrder[field.value] = index + 1;
        });
        return newOrder;
      });
    }
  };

  const [sortOrders, setSortOrders] = useState(() => {
    const saved = localStorage.getItem("sortOrdersSubscriber");
    return saved ? JSON.parse(saved) : {};
  });

  const handleSortOrderChange = (fieldValue, order) => {
    setSortOrders({
      ...sortOrders,
      [fieldValue]: order,
    });
  };

  const handleApplySorting = () => {
    const sortingConfig = selectedFields.map((field) => ({
      key: field.value,
      direction: sortOrders[field.value] || 'asc',
    }));

    localStorage.setItem("sortConfigSubscriberList", JSON.stringify(sortingConfig));
    setSortConfig(sortingConfig);
    GetSubscriberList(currentPage, sortingConfig);
    handleSortingPopupClose();
  };

  useEffect(() => {
    setSelectedCheckboxes(sortConfig.map(col => col.key));
  }, [sortConfig]);

  useEffect(() => {
    if (selectedFields) {
      localStorage.setItem("selectedFieldsSubscriber", JSON.stringify(selectedFields));
    }
    if (selectionOrder) {
      localStorage.setItem("selectionOrderSubscriber", JSON.stringify(selectionOrder));
    }
    if (sortOrders) {
      localStorage.setItem("sortOrdersSubscriber", JSON.stringify(sortOrders));
    }
  }, [selectedFields, selectionOrder, sortOrders]);

  const [selectedSubscriber, setSelectedSubscriber] = useState(null);

  const normalizeDataTypeValue = (value) => {
    if (value === undefined || value === null) {
      return "";
    }

    return String(value).trim().toLowerCase();
  };

  const extractDataTypeIdentifiers = (item = {}) => {
    const nestedDataType = item?.data_type || item?.datatype || item?.subscription_data_type;

    return [
      item?.id,
      item?.data_type_id,
      item?.value,
      item?.subscription_data_type_id,
      nestedDataType?.id,
      item?.title,
      item?.name,
      item?.label,
      item?.data_type_name,
      nestedDataType?.title,
      nestedDataType?.name,
      nestedDataType?.label,
    ]
      .map(normalizeDataTypeValue)
      .filter(Boolean);
  };

  const getMatchedSelectedDataTypes = (subscriber, options = subscriptionDataTypeOptions) => {
    if (!subscriber?.data_types?.length || !options?.length) {
      return [];
    }

    const selectedIdentifiers = new Set(
      subscriber.data_types.flatMap((item) => extractDataTypeIdentifiers(item))
    );

    return options.filter((option) =>
      selectedIdentifiers.has(normalizeDataTypeValue(option?.value)) ||
      selectedIdentifiers.has(normalizeDataTypeValue(option?.label))
    );
  };

  useEffect(() => {
    if (!showDataTypesEditor) {
      return;
    }

    setSelectedDataTypeOptions(getMatchedSelectedDataTypes(selectedSubscriber));
  }, [showDataTypesEditor, selectedSubscriber, subscriptionDataTypeOptions]);

  const handleRowClick = (subscriber) => {
    setSelectedSubscriber(subscriber);
    setShowOffcanvas(true);
  };

  const handleOpenDataTypesPopup = () => {
    if (!selectedSubscriber) return;

    setSelectedDataTypeOptions(getMatchedSelectedDataTypes(selectedSubscriber));
    setDataTypeErrorMessage("");
    setShowDataTypesEditor(true);
  };

  const handleCloseDataTypesPopup = () => {
    setShowDataTypesEditor(false);
    setSelectedDataTypeOptions([]);
    setDataTypeErrorMessage("");
  };

  const handleCloseSubscriberDetails = () => {
    handleCloseDataTypesPopup();
    setShowOffcanvas(false);
  };

  const handleEditDataTypeChange = (selectedItems) => {
    const dataTypeLimit = Number(selectedSubscriber?.data_type_limit || 0);

    if (dataTypeLimit > 0 && selectedItems.length > dataTypeLimit) {
      setDataTypeErrorMessage(
        `Please select exactly ${dataTypeLimit} data type(s) for the ${selectedSubscriber?.subscription_title || "current"} plan.`
      );
      return;
    }

    setSelectedDataTypeOptions(selectedItems);
    setDataTypeErrorMessage("");
  };

  const handleSaveDataTypes = async () => {
    const dataTypeLimit = Number(selectedSubscriber?.data_type_limit || 0);

    if (!selectedSubscriber?.id) {
      setDataTypeErrorMessage("Unable to update the subscriber. Please try again.");
      return;
    }

    if (dataTypeLimit > 0 && selectedDataTypeOptions.length !== dataTypeLimit) {
      setDataTypeErrorMessage(
        `Please select exactly ${dataTypeLimit} data type(s) for the ${selectedSubscriber?.subscription_title || "current"} plan before saving.`
      );
      return;
    }

    setIsSavingDataTypes(true);
    setDataTypeErrorMessage("");

    try {
      const payload = {
        id: selectedSubscriber.id,
        user_subscription_data_types: selectedDataTypeOptions.map((item) => item.value),
      };

      const responseData = await AdminSubscriberService.updateSubscriptionDataType(payload).json();

      if (responseData.status !== true && responseData.status !== "success") {
        setDataTypeErrorMessage(responseData?.message || "Unable to update active data types.");
        return;
      }

      // const refreshedResponse = await fetchSubscriberListData(currentPage, sortConfig);

      const refreshedResponse = await fetchSubscriberListData(
        currentPage,
        sortConfig,
        filterQuery
      );

      if (refreshedResponse.status === true) {
        setSubscriberList(refreshedResponse.data);
        setNpage(Math.ceil(refreshedResponse.data.length / recordsPage));
        setSubscriberListCount(refreshedResponse.data.length);

        const updatedSubscriber = refreshedResponse.data.find(
          (subscriber) => subscriber.id === selectedSubscriber.id
        );

        if (updatedSubscriber) {
          setSelectedSubscriber(updatedSubscriber);
        }
      }

      setShowDataTypesEditor(false);
      swal(responseData?.message || "Active data types updated successfully.");
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
        setDataTypeErrorMessage(errorJson?.message || "Unable to update active data types.");
      } else {
        setDataTypeErrorMessage("Unable to update active data types.");
      }
    } finally {
      setIsSavingDataTypes(false);
    }
  };

  const handleFilterInputChange = (name, value) => {
    setFilterQuery((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const HandleFilterForm = (e) => {
    e.preventDefault();

    setManageFilterOffcanvas(false);
    setCurrentPage(1);

    GetSubscriberList(1, sortConfig, filterQuery);
  };

  const HandleCancelFilter = (e) => {
    if (e) {
      e.preventDefault();
    }

    setManageFilterOffcanvas(false);
    setFilterQuery(defaultFilters);
    setCurrentPage(1);

    GetSubscriberList(1, sortConfig, defaultFilters);
  };

  const isSubscriptionCancelled = selectedSubscriber?.subscription_status == "cancelled" || (selectedSubscriber?.subscription_cancelled_at != null && selectedSubscriber?.subscription_status != "scheduled_for_cancellation");

  const isValidValue = (value) => {
    return value !== null && value !== undefined && value !== "" && value !== "NA";
  };

  const StatusOptions = [
    { value: "active", label: "Active" },
    { value: "pending", label: "Pending" },
    { value: "scheduled_for_cancellation", label: "Scheduled for Cancellation" },
    { value: "cancelled", label: "Cancelled" },
    // { value: "expired", label: "Expired" },
  ];

  const PaymentStatusOptions = [
    { value: "refunded", label: "Refunded" },
    { value: "pending", label: "Pending" },
    { value: "paid", label: "Paid" },
  ];

  const confirmApprove = async (id, newStatus, name) => {
    Swal.fire({
      title: "",
      html: `Do you want to ${newStatus == true ? "active" : "inactive"} this <b>${name}</b> user?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, approve",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        handleToggle(id, newStatus);
      }
    });
  };

  const handleToggle = async (id, newStatus) => {
    const statusValue = newStatus ? 1 : 0;

    setUpdatingUserId(id);

    const userData = {
      id: id,
      status: statusValue,
    };

    try {
      const request = await AdminUserRoleService.change_status(userData);

      if (request.status === 200) {
        setSelectedSubscriber((prev) => {
          if (!prev) return prev;

          return {
            ...prev,
            user: Array.isArray(prev.user)
              ? prev.user.map((user) =>
                user.id === id ? { ...user, status: statusValue } : user
              )
              : prev.user,
          };
        });

        setSubscriberList((prev) =>
          prev.map((subscriber) => ({
            ...subscriber,
            user: Array.isArray(subscriber.user)
              ? subscriber.user.map((user) =>
                user.id === id ? { ...user, status: statusValue } : user
              )
              : subscriber.user,
          }))
        );

        swal({
          text: "Status changed successfully.",
        });
      }
    } catch (error) {
      console.error("Failed to update status:", error);

      if (error.name === "HTTPError") {
        const errorJson = error.body || { message: error.message };
        if (errorJson?.error_code === "seat_limit_reached" || errorJson?.upgrade_required) {
          showSeatLimitUpgradePrompt(errorJson.message);
          return;
        }
      }

      swal({
        text: "Failed to update status. Please try again.",
        icon: "error",
      });
    } finally {
      setUpdatingUserId(null);
    }
  };

  const showSeatLimitUpgradePrompt = (message) => {
    if (SyestemUserRole === "Admin" || SyestemUserRole === "Staff") {
      Swal.fire({
        text: "The account reached seat limit. Upgrade the seat plan to activate additional users.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    Swal.fire({
      text: message || "You've reached your seat limit. Upgrade your seat plan to activate additional users.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Upgrade Seats",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/subscriptionplan");
      }
    });
  };

  const GetSubscriptionPlanList = async () => {
    setIsFilterLoading(true);
    try {
      const responseData = await AdminSubscriberService.getSubscriptionPlanList().json();
      if (responseData.status === true) {
        const planOptions = responseData.data.map((plan) => ({
          label: plan.title,
          value: plan.type,
          type: plan.type,
        }));
        setSubscriptionPlanList(planOptions);
        setIsFilterLoading(false);
      }
    } catch (error) {
      setIsFilterLoading(false);
      if (error.name === "HTTPError") {
      }
    }
  };

  const GetUserCompanyList = async () => {
    setIsFilterLoading(true);
    try {
      let responseData = await AdminUserRoleService.user_companies().json();
      setIsFilterLoading(false);
      const companyOptions = responseData?.map((item) => ({
        label: item,
        value: item,
      }));
      setCompanyOptions(companyOptions);
    } catch (error) {
      setIsFilterLoading(false);
      if (error.name === 'HTTPError') {
      }
    }
  };

  const getSortArrow = (key) => {
    const sortItem = sortConfig.find((item) => item.key === key);

    if (!sortItem) return "";

    return sortItem.direction === "asc" ? " ↑" : " ↓";
  };

  return (
    <Fragment>
      <MainPagetitle
        mainTitle="Subscribers List"
        pageTitle="Subscribers List"
        parentTitle="Home"
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                  <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center pb-0">
                    <div className="d-flex text-nowrap justify-content-between align-items-center">
                      <h4 className="heading mb-0">Subscribers List</h4>
                    </div>
                    <div className="mt-2" style={{ width: "100%" }}>
                      {(SyestemUserRole == "Admin" ||
                        SyestemUserRole == "Staff") && (
                          <div className="d-flex">
                            {/* Button place */}
                            <Button
                              className="btn-sm me-2"
                              variant="secondary"
                              onClick={HandleSortingPopupDetailClick}
                              title="Sorted Fields"
                            >
                              <div style={{ fontSize: "11px" }}>
                                <i className="fa-solid fa-sort"></i>&nbsp; Sort
                              </div>
                            </Button>
                            <button className="btn btn-success btn-sm me-1" onClick={() => setManageFilterOffcanvas(true)} title="Filter">
                              <div style={{ fontSize: "11px" }}>
                                <i className="fa fa-filter" />&nbsp;
                                Filter
                              </div>
                            </button>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                    <div className="dataTables_info">
                      Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                      {subscriberListCount} entries
                    </div>
                    <div
                      className="dataTables_paginate paging_simple_numbers justify-content-center"
                      id="example2_paginate"
                    >
                      <Link
                        className="paginate_button previous disabled"
                        to="#"
                        onClick={prePage}
                      >
                        <i className="fa-solid fa-angle-left" />
                      </Link>
                      <span>
                        {number.map((n, i) => {
                          if (number.length > 4) {
                            if (
                              i === 0 ||
                              i === number.length - 1 ||
                              Math.abs(currentPage - n) <= 1 ||
                              (i === 1 && n === 2) ||
                              (i === number.length - 2 &&
                                n === number.length - 1)
                            ) {
                              return (
                                <Link
                                  className={`paginate_button ${currentPage === n ? "current" : ""
                                    } `}
                                  key={i}
                                  onClick={() => changeCPage(n)}
                                >
                                  {n}
                                </Link>
                              );
                            } else if (i === 1 || i === number.length - 2) {
                              return <span key={i}>...</span>;
                            } else {
                              return null;
                            }
                          } else {
                            return (
                              <Link
                                className={`paginate_button ${currentPage === n ? "current" : ""
                                  } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            );
                          }
                        })}
                      </span>

                      <Link
                        className="paginate_button next"
                        to="#"
                        onClick={nextPage}
                      >
                        <i className="fa-solid fa-angle-right" />
                      </Link>
                    </div>
                  </div>
                  <div
                    id="employee-tbl_wrapper"
                    className="dataTables_wrapper no-footer"
                  >
                    {isLoading ? (
                      <div className="d-flex justify-content-center align-items-center mb-5">
                        <ClipLoader color="#4474fc" />
                      </div>
                    ) : (
                      <table
                        id="empoloyees-tblwrapper"
                        className="table ItemsCheckboxSec dataTable no-footer mb-0 subscriber-table"
                      >
                        <thead>
                          <tr style={{ textAlign: "center" }}>
                            <th>No.</th>
                            <th>Company Name{getSortArrow("company")}</th>
                            <th>Name{getSortArrow("name")}</th>
                            <th>Last Name{getSortArrow("last_name")}</th>
                            <th>Email{getSortArrow("email")}</th>
                            <th>Seats{getSortArrow("seats")}</th>
                            <th>Subscription Plan{getSortArrow("subscription_title")}</th>
                            <th>Subscription Status{getSortArrow("subscription_status")}</th>
                            <th>Subscription Price{getSortArrow("subscription_price")}</th>
                            <th>Payment Status{getSortArrow("payment_status")}</th>
                            <th>Subscription Start{getSortArrow("subscription_start_at")}</th>
                            {/* <th>Subscription Renewed{getSortArrow("subscription_renewed_at")}</th> */}
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {subscriberList !== null &&
                            subscriberList.length > 0 ? (
                            subscriberList.map((element, index) => (
                              <tr
                                style={{
                                  textAlign: "center",
                                  cursor: "pointer",
                                }}
                                onClick={() => handleRowClick(element)}
                              >
                                <td>{index + 1}</td>
                                <td>{element.company}</td>
                                <td>{element.user_name}</td>
                                <td>{element.user_last_name}</td>
                                <td>{element.user_email}</td>
                                <td>{`${element.current_used_seats}/${element.total_seats} ${element.current_used_seats == 1 ? "Seat" : "Seats"} Used`}</td>
                                <td>{element.subscription_title}</td>
                                <td>
                                  {element.subscription_status === "scheduled_for_cancellation" ? (
                                    <span className="badge" style={{ backgroundColor: "#fef3c7", color: "#92400e", border: "1px solid #fde68a" }}>
                                      Scheduled for Cancellation
                                    </span>
                                  ) : element.subscription_status === "active" ? (
                                    <span className="badge" style={{ backgroundColor: "#e8f8ee", color: "#1f9254" }}>
                                      Active
                                    </span>
                                  ) : element.subscription_status === "cancelled" ? (
                                    <span className="badge" style={{ backgroundColor: "#fdecec", color: "#d93025" }}>
                                      Cancelled
                                    </span>
                                  ) : (
                                    element.subscription_status
                                  )}
                                </td>
                                <td>
                                  {
                                    <PriceComponent
                                      price={element.subscription_price}
                                    />
                                  }
                                </td>
                                <td>{element.payment_status}</td>
                                <td>{element.subscription_start_at}</td>
                                {/* <td>{element.subscription_renewed_at}</td> */}
                                <td>
                                  <div className="d-flex justify-content-center">
                                    <Link
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        swal({
                                          title: "Are you sure?",
                                          icon: "warning",
                                          buttons: true,
                                          dangerMode: true,
                                        }).then((willDelete) => {
                                          if (willDelete) {
                                            handleDelete(element.id);
                                          }
                                        });
                                      }}
                                      className="btn btn-danger shadow btn-xs sharp"
                                    >
                                      <i className="fa fa-trash"></i>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td>No data found</td>
                              <td colSpan="8"></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                    <div className="dataTables_info">
                      Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                      {subscriberListCount} entries
                    </div>
                    <div
                      className="dataTables_paginate paging_simple_numbers justify-content-center"
                      id="example2_paginate"
                    >
                      <Link
                        className="paginate_button previous disabled"
                        to="#"
                        onClick={prePage}
                      >
                        <i className="fa-solid fa-angle-left" />
                      </Link>
                      <span>
                        {number.map((n, i) => {
                          if (number.length > 4) {
                            if (
                              i === 0 ||
                              i === number.length - 1 ||
                              Math.abs(currentPage - n) <= 1 ||
                              (i === 1 && n === 2) ||
                              (i === number.length - 2 &&
                                n === number.length - 1)
                            ) {
                              return (
                                <Link
                                  className={`paginate_button ${currentPage === n ? "current" : ""
                                    } `}
                                  key={i}
                                  onClick={() => changeCPage(n)}
                                >
                                  {n}
                                </Link>
                              );
                            } else if (i === 1 || i === number.length - 2) {
                              return <span key={i}>...</span>;
                            } else {
                              return null;
                            }
                          } else {
                            return (
                              <Link
                                className={`paginate_button ${currentPage === n ? "current" : ""
                                  } `}
                                key={i}
                                onClick={() => changeCPage(n)}
                              >
                                {n}
                              </Link>
                            );
                          }
                        })}
                      </span>

                      <Link
                        className="paginate_button next"
                        to="#"
                        onClick={nextPage}
                      >
                        <i className="fa-solid fa-angle-right" />
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showSort} onHide={HandleSortDetailClick}>
        <Modal.Header handleSortClose>
          <Modal.Title>Sorted Fields</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {sortConfig.length > 0 ? (
            sortConfig.map((col) => (
              <div className="row" key={col.key}>
                <div className="col-md-6">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      name={col.key}
                      defaultChecked={true}
                      id={`checkbox-${col.key}`}
                      onChange={(e) => handleSortCheckboxChange(e, col.key)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`checkbox-${col.key}`}
                    >
                      <span>{col.key}</span>:<span>{col.direction}</span>
                    </label>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>N/A</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSortClose}>
            cancel
          </Button>
          <Button variant="primary" onClick={handleRemoveSelected}>
            Clear Sort
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Sorting */}
      <Modal show={showSortingPopup} onHide={HandleSortingPopupDetailClick}>
        <Modal.Header handleSortingPopupClose>
          <Modal.Title>Sorted Fields</Modal.Title>
          <button
            className="btn-close"
            aria-label="Close"
            onClick={() => handleSortingPopupClose()}
          ></button>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: "400px", overflowY: "auto" }}>
          <div className="row">
            <div style={{ marginTop: "-15px" }}>
              <label
                className="form-label"
                style={{ fontWeight: "bold", fontSize: "15px" }}
              >
                List of Fields:
              </label>
              <div className="field-checkbox-list">
                <div
                  className="form-check d-flex align-items-center mb-2"
                  style={{ width: "100%" }}
                >
                  <div
                    className="d-flex align-items-center"
                    style={{ flex: "0 0 40%" }}
                  >
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="select-all-fields"
                      checked={selectedFields.length === fieldOptions.length}
                      onChange={handleSelectAllChange}
                      style={{ marginRight: "0.2rem", cursor: "pointer" }}
                    />
                    <label
                      className="form-check-label mb-0"
                      htmlFor="select-all-fields"
                      style={{ width: "150px", cursor: "pointer" }}
                    >
                      Select All
                    </label>
                  </div>
                </div>

                {fieldOptions.map((field, index) => {
                  const isChecked = selectedFields.some(
                    (selected) => selected.value === field.value,
                  );
                  const fieldOrder = selectionOrder[field.value];

                  return (
                    <div
                      key={index}
                      className="form-check d-flex align-items-center mb-2"
                      style={{ width: "100%", height: "20px" }}
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{ flex: "0 0 40%" }}
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`field-checkbox-${index}`}
                          value={field.value}
                          checked={isChecked}
                          onChange={(e) =>
                            handleSortingCheckboxChange(e, field)
                          }
                          style={{ marginRight: "0.2rem", cursor: "pointer" }}
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor={`field-checkbox-${index}`}
                          style={{ width: "150px", cursor: "pointer" }}
                        >
                          {isChecked && <span>{fieldOrder}. </span>}
                          {field.label}
                        </label>
                      </div>

                      {isChecked && (
                        <div
                          className="radio-group d-flex"
                          style={{ flex: "0 0 60%", paddingTop: "5px" }}
                        >
                          <div
                            className="form-check form-check-inline"
                            style={{ flex: "0 0 50%" }}
                          >
                            <input
                              type="radio"
                              className="form-check-input"
                              name={`sortOrder-${field.value}`}
                              id={`asc-${field.value}`}
                              value="asc"
                              checked={
                                sortOrders[field.value] === "asc" ||
                                !sortOrders[field.value]
                              }
                              onChange={() =>
                                handleSortOrderChange(field.value, "asc")
                              }
                              style={{ cursor: "pointer" }}
                            />
                            <label
                              className="form-check-label mb-0"
                              htmlFor={`asc-${field.value}`}
                              style={{ cursor: "pointer", marginLeft: "-40px" }}
                            >
                              Ascending
                            </label>
                          </div>
                          <div
                            className="form-check form-check-inline"
                            style={{ flex: "0 0 50%" }}
                          >
                            <input
                              type="radio"
                              className="form-check-input"
                              name={`sortOrder-${field.value}`}
                              id={`desc-${field.value}`}
                              value="desc"
                              checked={sortOrders[field.value] === "desc"}
                              onChange={() =>
                                handleSortOrderChange(field.value, "desc")
                              }
                              style={{ cursor: "pointer" }}
                            />
                            <label
                              className="form-check-label mb-0"
                              htmlFor={`desc-${field.value}`}
                              style={{ cursor: "pointer", marginLeft: "-30px" }}
                            >
                              Descending
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleSortingPopupClose}
            style={{ marginRight: "10px" }}
          >
            Close
          </Button>
          <Button
            variant="success"
            onClick={() => handleApplySorting(selectedFields, sortOrders)}
          >
            Apply
          </Button>
        </Modal.Footer>
      </Modal>

      <Offcanvas
        show={showOffcanvas}
        onHide={handleCloseSubscriberDetails}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Subscriber Details{" "}
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={handleCloseSubscriberDetails}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="offcanvas-body">
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center mb-5">
              <ClipLoader color="#4474fc" />
            </div>
          ) : selectedSubscriber ? (
            <div className="active-plan-banners">
              <div className="banner-content">
                <div className="info-group">
                  <div className="info-item">
                    <span className="label">Current Plan</span>
                    <span className="value highlighting">
                      {selectedSubscriber?.subscription_title || "NA"} Plan
                    </span>
                  </div>
                  {selectedSubscriber?.subscription_status === "scheduled_for_cancellation" || selectedSubscriber?.cancellation_requested_at ? (
                    <>
                      <div className="info-item">
                        <span className="label">Cancellation Request Date</span>
                        <span className="value highlighting">
                          {isValidValue(selectedSubscriber?.cancellation_requested_at) ? (
                            <DateComponent
                              date={selectedSubscriber?.cancellation_requested_at}
                              subscribPaln={true}
                            />
                          ) : (
                            "NA"
                          )}
                        </span>
                      </div>
                      <div className="info-item">
                        <span className="label">Subscription Expiration Date</span>
                        <span className="value highlighting">
                          {isValidValue(selectedSubscriber?.subscription_end_at) ? (
                            <DateComponent
                              date={selectedSubscriber?.subscription_end_at}
                              subscribPaln={true}
                            />
                          ) : (
                            "NA"
                          )}
                        </span>
                      </div>
                    </>
                  ) : (
                    <div className="info-item">
                      <span className="label">Renewal Date</span>
                      <span className="value highlighting">
                        {isValidValue(selectedSubscriber?.subscription_end_at) ? (
                          <DateComponent
                            date={selectedSubscriber?.subscription_end_at || "NA"}
                            subscribPaln={true}
                          />
                        ) : (
                          "NA"
                        )}
                      </span>
                    </div>
                  )}
                  <div className="info-item">
                    <span className="label">Usage Limits</span>
                    <span className="value highlighting">
                      {selectedSubscriber?.total_seats || "NA"} Seats |{" "}
                      {selectedSubscriber?.data_type_limit || "NA"} Data Types
                    </span>
                  </div>
                </div>

                <div className="info-item data-types-full-width">
                  <div className="d-flex align-items-center gap-2 flex-wrap mb-1">
                    <span className="label mb-0">Active Data Types</span>
                    <button
                      type="button"
                      className="btn btn-primary shadow btn-xs sharp"
                      onClick={handleOpenDataTypesPopup}
                      disabled={isSubscriptionCancelled}
                      style={{
                        width: "5px",
                        height: "5px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "6px",
                        padding: 0,
                        opacity: isSubscriptionCancelled ? 0.5 : 1,
                        cursor: isSubscriptionCancelled ? "not-allowed" : "pointer",
                      }}
                    >
                      <i className="fas fa-pencil-alt"></i>
                    </button>
                  </div>
                  <span className="value highlighting small-text">
                    {selectedSubscriber?.data_types?.length
                      ? selectedSubscriber?.data_types
                        ?.map((i) => i.title)
                        .join(", ")
                      : "NA"}
                  </span>
                </div>
                {showDataTypesEditor && (
                  <div
                    className="info-item data-types-full-width"
                    style={{
                      border: "1px solid #e5e7eb",
                      borderRadius: "14px",
                      background: "#fff",
                      boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
                      padding: "16px 14px",
                    }}
                  >
                    {dataTypeErrorMessage && (
                      <div
                        className="text-danger mb-2"
                        style={{ fontSize: "13px" }}
                      >
                        {dataTypeErrorMessage}
                      </div>
                    )}
                    <div className="row g-3">
                      <div className="col-12">
                        <label
                          className="form-label fw-semibold"
                          style={{ fontSize: "14px", color: "#1f2937" }}
                        >
                          Select Data Type{" "}
                          {selectedSubscriber?.data_type_limit && (
                            <span
                              className="data-type-note"
                            >
                              (Select at least{" "}
                              {selectedSubscriber.data_type_limit} data type
                              {selectedSubscriber.data_type_limit > 1
                                ? "s"
                                : ""}
                              .)
                            </span>
                          )}<span className="text-danger">*</span>
                        </label>
                        <MultiSelect
                          options={subscriptionDataTypeOptions}
                          value={selectedDataTypeOptions}
                          onChange={handleEditDataTypeChange}
                          isOptionDisabled={(option) =>
                            Number(selectedSubscriber?.data_type_limit || 0) >
                            0 &&
                            selectedDataTypeOptions.length >=
                            Number(
                              selectedSubscriber?.data_type_limit || 0,
                            ) &&
                            !selectedDataTypeOptions.some(
                              (selectedOption) =>
                                normalizeDataTypeValue(
                                  selectedOption?.value,
                                ) === normalizeDataTypeValue(option?.value),
                            )
                          }
                          placeholder="Select data types..."
                        />
                      </div>
                      <div className="d-flex justify-content-start gap-2 pt-1">
                        <Button
                          variant="primary"
                          onClick={handleSaveDataTypes}
                          disabled={isSavingDataTypes}
                          style={{
                            minWidth: "54px",
                            borderRadius: "6px",
                            fontSize: "13px",
                            padding: "8px 14px",
                          }}
                        >
                          {isSavingDataTypes ? "Saving..." : "Save"}
                        </Button>
                        <Button
                          className="btn btn-danger light ms-1"
                          onClick={handleCloseDataTypesPopup}
                        >
                          Cancel
                        </Button>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    overflowX: "auto",
                    WebkitOverflowScrolling: "touch",
                  }}
                  className="info-item data-types-full-width"
                >
                  <span className="label">Assigned Users</span>
                  <span
                    style={{ width: "100%" }}
                    className="value highlighting small-text"
                  >
                    {selectedSubscriber?.user && (
                      <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                        <div
                          id="employee-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="empoloyees-tblwrapper"
                            className="table ItemsCheckboxSec dataTable no-footer product-table-price mb-0"
                          >
                            <thead>
                              <tr style={{ textAlign: "center" }}>
                                <th>
                                  <strong>No.</strong>
                                </th>
                                <th>
                                  <strong>Status</strong>
                                </th>
                                <th>
                                  <strong>Name</strong>
                                </th>
                                <th>
                                  <strong>Last Name</strong>
                                </th>
                                <th>
                                  <strong>Email</strong>
                                </th>
                                <th>
                                  <strong>Role</strong>
                                </th>
                              </tr>
                            </thead>
                            <tbody style={{ textAlign: "center" }}>
                              {selectedSubscriber.user &&
                                Array.isArray(selectedSubscriber.user) &&
                                selectedSubscriber.user.length > 0 ? (
                                selectedSubscriber.user.map(
                                  (element, index) => (
                                    <tr
                                      key={element.id}
                                      style={{
                                        textAlign: "center",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <td>{index + 1}</td>
                                      <td>
                                        <div
                                          className="d-flex justify-content-center align-items-center"
                                          style={{ minHeight: "32px" }}
                                        >
                                          {updatingUserId === element.id ? (
                                            <div
                                              className="d-flex justify-content-center align-items-center"
                                              style={{ width: "40px", height: "24px" }}
                                            >
                                              <ClipLoader size={14} color="#4474fc" />
                                            </div>
                                          ) : (
                                            <div className="form-check form-switch m-0">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                role="switch"
                                                checked={Number(element.status) === 1}
                                                disabled={updatingUserId === element.id}
                                                onChange={(e) =>
                                                  confirmApprove(element.id, e.target.checked, element.name)
                                                }
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        {element.name
                                          ? capitalizeFirstLetter(element.name)
                                          : ""}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {element.last_name
                                          ? capitalizeFirstLetter(
                                            element.last_name,
                                          )
                                          : ""}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {element.email ? element.email : ""}
                                      </td>
                                      <td style={{ textAlign: "center" }}>
                                        {element.roles &&
                                          Array.isArray(element.roles)
                                          ? element.roles
                                            .map((role) => role.name)
                                            .join(", ")
                                          : ""}
                                      </td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    No data found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <p>No subscriber data available</p>
          )}
        </div>
      </Offcanvas>

      {/* Filter */}
      <Offcanvas
        show={manageFilterOffcanvas}
        onHide={setManageFilterOffcanvas}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="modal-title" id="#gridSystemModal">
            Filter Subscribers
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => setManageFilterOffcanvas(false)}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        {/* {isFilterLoading ? (
          <div className="d-flex justify-content-center align-items-center mt-5 mb-5">
            <ClipLoader color="#4474fc" />
          </div>
        ) : ( */}
        <div className="offcanvas-body">
          <div className="container-fluid">
            <form onSubmit={HandleFilterForm}>
              <div className="row">
                <div className="col-md-3 mt-3">
                  <label className="form-label">COMPANY NAME:</label>
                  <MultiSelect
                    name="company"
                    options={companyOptions}
                    value={filterQuery.company}
                    onChange={(selected) =>
                      handleFilterInputChange("company", selected)
                    }
                    placeholder="Select Company"
                    hasSelectAll={true}
                  />
                </div>

                <div className="col-md-3 mt-3">
                  <label className="form-label">PLAN:</label>
                  <MultiSelect
                    name="plan"
                    options={subscriptionPlanList}
                    value={filterQuery.plan}
                    onChange={(selected) =>
                      handleFilterInputChange("plan", selected)
                    }
                    placeholder="Select Plan"
                    hasSelectAll={true}
                  />
                </div>

                <div className="col-md-3 mt-3">
                  <label className="form-label">STATUS:</label>
                  <MultiSelect
                    name="status"
                    options={StatusOptions}
                    value={filterQuery.status}
                    onChange={(selected) =>
                      handleFilterInputChange("status", selected)
                    }
                    placeholder="Select Status"
                    hasSelectAll={true}
                  />
                </div>

                <div className="col-md-3 mt-3">
                  <label className="form-label">PAYMENT STATUS:</label>
                  <MultiSelect
                    name="payment_status"
                    options={PaymentStatusOptions}
                    value={filterQuery.payment_status}
                    onChange={(selected) =>
                      handleFilterInputChange("payment_status", selected)
                    }
                    placeholder="Select Payment Status"
                    hasSelectAll={true}
                  />
                </div>

                <div className="col-md-3 mt-3">
                  <label className="form-label">PRICE:</label>
                  <input
                    type="text"
                    className="form-control"
                    value={filterQuery.price}
                    onChange={(e) =>
                      handleFilterInputChange("price", e.target.value)
                    }
                    placeholder="Enter Price"
                  />
                </div>
              </div>
            </form>

            <br />

            <div className="d-flex justify-content-between">
              <Button
                className="btn-sm"
                onClick={HandleCancelFilter}
                variant="secondary"
              >
                Reset
              </Button>

              <Button
                className="btn-sm"
                onClick={HandleFilterForm}
                variant="primary"
              >
                Filter
              </Button>
            </div>
          </div>
        </div>
        {/* )} */}
      </Offcanvas>
    </Fragment>
  );
}

export default SubscriberList;
